module.exports = __webpack_public_path__ + "hero2.b182d5905d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/mpaq/hero2.jpg
// module id = ./src/styles/marketing/mpaq/hero2.jpg
// module chunks = 21